var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ATag,{staticClass:"blocked-tag"},[_c(_setup.AIcon,{attrs:{"type":"warning","theme":"filled"}}),_c('span',[_vm._v(_vm._s(_vm.$t('blocked')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }